module.exports = __webpack_public_path__ + "img/DK.8729e003.png";